module.exports = {"id":"219754","name":"Bruno Varela","rating":"76","photo":"./data/images/photos/4/219754.png","club":{"name":"SL Benfica","logo":"./data/images/clubs/SLBenfica.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrunoVarela0.json
// module id = 669
// module chunks = 0